module.exports = __webpack_public_path__ + "static/media/Handschalter mit Lupe.c46a6639.png";